import React from 'react';
import { compose } from 'ramda';

import styleFile from './inputField.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withForm } from './';

export default compose(
  withForm(),
  PropertyManager([
    'type',
    'form',
    'formModel',
    'validations',
    'model',
    'css',
    'validationsFields',
    'defaultValue',
    'disabled',
    'autoFocus',
    'transform'
  ]),
  withThemeJSS({ styleFile })
)(
  class InputField extends React.Component {
    static displayName = 'InputField';
    constructor(props) {
      super(props);

      const { form, model, defaultValue = '', validations = [], validationsFields, autoFocus } = this.props.config;
      
      form.subscribe({
        model: model,
        onChange: this.change,
        forceUpdate: this.forceUpdate,
        validations: validations,
        defaultValue: defaultValue,
        value: defaultValue,
        validationsFields: validationsFields,
        autoFocus: autoFocus
      });

      this.state = {
        value: this.toModel(defaultValue),
        autoFocused: autoFocus,
        userInteracted: false
      };
    }

    /*componentDidUpdate = () => {
      //this.subscribe();
    };*/

    componentDidMount = () => { };

    onBlur = e => {
      const { config } = this.props;
      const { form, formModel } = config;
      
      // Si fue auto enfocado y no ha perdido el foco antes, y el usuario no ha interactuado
      if (this.state.autoFocused && !this.state.hasBlurred && !this.state.userInteracted) {
        this.setState({ hasBlurred: true });
        return; // No hacer nada en el primer onBlur si fue auto enfocado y no ha habido interacción del usuario
      }
      

      config.form.onGlobalChange(config.model, this.toModel(e && e.target.value)).then(() => {
        if (!formModel.visited) {
          form.updateModel(config.model, { visited: true });
        }
        form.onGlobalBlur(config.model);
      });

    };

    toModel = (value) => {
      if (this.props.config?.transform) {
        return this.props.config?.transform(value);
      } else {
        return value;
      }
    }

    onChange = event => {
      const value = event && event.target.value;
      this.setState({ userInteracted: true });
      this.change(value);
    };

    change = (value, preventCallback) => {
      const { config } = this.props;
      const { form } = config;

      form.updateModel(config.model, { visited: false });
      return new Promise((resolve) => {
        this.setState({ value: value }, () => {
          if(preventCallback) {
            config.form.onGlobalChange(config.model, this.toModel(value), preventCallback).then(()=>{
              return resolve();
            });
          } else {            
            this.setTimerBeforeCallback(this.toModel(value), preventCallback);
            resolve();
          }
        });
      });
    };

    componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      const { form, model } = this.props.config;
      
      form.unSubscribe({ model: model });
    }

    setTimerBeforeCallback(value, preventCallback) {
      const { config } = this.props;

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        config.form.onGlobalChange(config.model, value, preventCallback);
      }, 150);
    }

    render = () => {
      const { value } = this.state;
      const { theme, config } = this.props;
      const { form, formModel, placeHolder, model, type = 'text', css, autoFocus } = config;
      return (
        (formModel && (
          <input
            className={[form.getValidClass(formModel, css, theme), theme.computedInnerStyle].join(' ')}
            onChange={this.onChange}
            disabled={config.disabled}
            value={value || ''}
            onBlur={this.onBlur}
            type={type}
            name={model}
            placeholder={placeHolder}
            autoFocus={autoFocus || false}
          />
        )) ||
        null
      );
    };
  }
);
